import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { readConsent, writeConsent, loadMarketingScripts, REOPEN_EVENT } from '@/lib/consent';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  // Decide once on mount whether to show the banner, and re-load marketing
  // scripts if the visitor already consented in a previous session.
  useEffect(() => {
    const existing = readConsent();
    if (existing) {
      if (existing.marketing) loadMarketingScripts();
    } else {
      setVisible(true);
    }
    const onReopen = () => setVisible(true);
    window.addEventListener(REOPEN_EVENT, onReopen);
    return () => window.removeEventListener(REOPEN_EVENT, onReopen);
  }, []);

  const decide = (marketing) => {
    writeConsent(marketing);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Cookie-Einwilligung"
      data-testid="cookie-consent-banner"
      className="fixed inset-x-0 bottom-0 z-[9999] px-4 pb-4 sm:px-6 sm:pb-6 pointer-events-none"
    >
      <div className="pointer-events-auto max-w-5xl mx-auto bg-white border border-slate-200 shadow-[0_10px_40px_-10px_rgba(15,23,42,0.25)] rounded-md overflow-hidden">
        <div className="grid md:grid-cols-[1fr_auto] gap-5 p-5 sm:p-6 items-center">
          <div>
            <div className="font-mono-tech text-[10px] uppercase tracking-[0.25em] text-[#0891b2] mb-2">
              Datenschutz
            </div>
            <p className="text-slate-700 text-sm leading-relaxed">
              Diese Website nutzt technisch notwendige Cookies. Zusätzlich möchten wir mit
              Ihrer Einwilligung Marketing- und Analyse-Cookies (LinkedIn Insight Tag,
              PostHog) einsetzen, um unsere Website zu verbessern und die Reichweite unserer
              LinkedIn-Kampagnen messen zu können. Sie können Ihre Auswahl jederzeit ändern.{' '}
              <Link
                to="/datenschutz"
                className="underline text-[#0891b2] hover:text-slate-900 transition-colors"
                data-testid="cookie-consent-privacy-link"
              >
                Details in der Datenschutzerklärung
              </Link>
              .
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-2.5 md:flex-col lg:flex-row md:min-w-[280px]">
            <button
              type="button"
              onClick={() => decide(false)}
              data-testid="cookie-consent-decline"
              className="px-5 py-2.5 rounded-sm border border-slate-300 text-slate-800 hover:bg-slate-50 hover:border-slate-400 transition-colors text-sm font-medium whitespace-nowrap"
            >
              Ablehnen
            </button>
            <button
              type="button"
              onClick={() => decide(true)}
              data-testid="cookie-consent-accept"
              className="px-5 py-2.5 rounded-sm bg-[#0891b2] hover:bg-[#0e7490] text-white transition-colors text-sm font-semibold whitespace-nowrap"
            >
              Alle akzeptieren
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
